<template>
  <div class="timer-background">
    <div v-on:click="openPopup" class="offer-timer">
      <div class="timer-and-title">
        <div class="timer-header">לא הרווחת – לא שילמת!</div>
        <subscription-mbg-timer-counter :end-date="mbgOfferEndDate" :hide-units="true" />
      </div>
      <img class="limited-time-banner" :src="require('@/assets/promotions/limited-time-offer-banner.svg')" />
      <div class="rotating-sun">
        <img :src="require('@/assets/sun4.svg')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SubscriptionMbgCtaPopup from '@/pages/responsive-pages/authenticated/trial/SubscriptionMbgCtaPopup';
import SubscriptionMbgTimerCounter
  from '@/pages/responsive-pages/authenticated/trial/money-back-offer/SubscriptionMbgTimerCounter';
import Segment from '@/Segment';

export default {
  name: 'SubscriptionMbgTimer',
  components: {
    SubscriptionMbgTimerCounter,
  },
  computed: {
    ...mapGetters('subscriptionState', ['mbgOfferEndDate']),
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    openPopup() {
      Segment.trackUserInteraction('SubscriptionCtaMbgPopupOpenedByCustomer');
      this.openModal({
        component: SubscriptionMbgCtaPopup,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~base-ui/src/scss/riseup-colors';

@keyframes spin {
  from {
    transform: rotate(-25deg);
  }
  to {
    transform: rotate(335deg);
  }
}

.timer-background {
  padding: 30px 0 0;

  .offer-timer {
    margin: 0px 0 0px;
    position: relative;
    overflow: hidden;
    height: 92px;
    border-radius: 5px;
    font-size: 16px;
    font-family: SimplerPro, sans-serif;
    cursor: pointer;
    line-height: 24px;
    background: $riseup_orange;

    .timer-and-title {
      ::v-deep .number, ::v-deep .divider {
        font-size: 36px;
      }

      ::v-deep .number {
        min-width: 40px;
      }

      padding: 14px 12px;
      text-align: right;

      .timer-header {
        font-size: 16px;
        line-height: 20px;
        font-weight: bold;
        color: white;
      }
    }

    .limited-time-banner {
      position: absolute;
      right: 183px;
      top: 26px;
      z-index: 2;
    }

    .rotating-sun {
      z-index: 1;
      position: absolute;
      left: -25px;
      top: 8px;

      img {
        width: 75px;
        animation: spin 20s linear infinite;
      }
    }
  }
}
</style>
